import React, { PureComponent } from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import { isEmpty } from '@widergy/web-utils/lib/array';
import { UTLabel } from '@widergy/energy-ui';

import UTCheckbox from '../UTCheckbox';

import UTCheckRow from './UTCheckRow';
import stylesJS from './styles';
import styles from './styles.module.scss';

class UTCheckList extends PureComponent {
  state = { selectAll: false };

  componentDidMount = () => {
    if (this.props.checked) this.handleCheckAll();
  };

  onChange = id => {
    const {
      input: { onChange, value }
    } = this.props;
    const newValues = value.indexOf(id) === -1 ? [...value, id] : value.filter(elem => elem !== id);
    onChange(isEmpty(newValues) ? null : newValues);
    this.setState({ selectAll: newValues && newValues.length === this.props.list.length });
  };

  handleCheckAll = () => {
    const {
      input: { onChange }
    } = this.props;
    this.setState(prevState => {
      if (!prevState.selectAll) {
        onChange(this.props.list.map(item => (this.props.userForm ? item.value : item.id)));
      } else {
        onChange(null);
      }
      return { selectAll: !prevState.selectAll };
    });
  };

  render() {
    return (
      <div style={stylesJS.container}>
        <div style={stylesJS.tableHeader}>
          {this.props.header &&
            this.props.header.map(item => (
              <UTLabel className={styles.headerItem} bold key={item.text}>
                {item.text}
              </UTLabel>
            ))}
          <UTCheckbox
            onChange={this.handleCheckAll}
            value={this.state.selectAll}
            label={this.props.headerLabel}
          />
        </div>
        {this.props.list.map(item => (
          <UTCheckRow
            key={item.id}
            item={item}
            onChange={this.onChange}
            value={this.props.input.value.indexOf(item.value || item.id) !== -1}
          />
        ))}
      </div>
    );
  }
}

UTCheckList.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.any
  }),
  header: PropTypes.arrayOf({
    text: PropTypes.string
  }),
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.numer,
      address: PropTypes.string,
      client_number: PropTypes.number
    })
  ),
  checked: PropTypes.bool,
  headerLabel: PropTypes.string,
  userForm: PropTypes.bool
};

export default Radium(UTCheckList);
